import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePartnerAuth } from '../contexts/PartnerAuthContext';
import { RefreshCw } from 'lucide-react';

const PartnerProtectedRoute = ({ children }) => {
  const { partner, loading } = usePartnerAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-purple-50">
        <div className="flex flex-col items-center gap-4">
          <RefreshCw className="animate-spin text-blue-600" size={40} />
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!partner) {
    return <Navigate to="/partner/login" replace />;
  }

  return children;
};

export default PartnerProtectedRoute;
